import React from 'react'

import { Button, Icon, Close } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string, node } from 'prop-types'

/**
 * Mobile-only modal used exclusively on physical mobile devices.
 *
 * Why this exists:
 * The My Models page has viewport meta tag disabled (see profile_data_controller? in shared_helper.rb),
 * which causes the standard Triangle UI Modal to render too small on mobile devices.
 * This custom modal provides properly sized elements that work without viewport scaling.
 *
 * Note: This modal is NOT used for responsive desktop views - only for physical mobile devices
 * detected via screen.width.
 */
function PerformanceModalMobile({ title, onClose, children }) {
  return (
    <div className="performance-modal-mobile">
      <div className="performance-modal-mobile__backdrop" onClick={onClose} aria-hidden="true" />
      <div
        className="performance-modal-mobile__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="performance-modal-title"
      >
        <div className="performance-modal-mobile__header">
          <span id="performance-modal-title" className="performance-modal-mobile__title">{title}</span>
          <Button
            type="ghost-primary"
            variant="only-icon"
            icon={<Icon svgComponent={Close} />}
            onClick={onClose}
            customClass="performance-modal-mobile__close-btn"
            aria-label="Close modal"
          />
        </div>
        <div className="performance-modal-mobile__body">
          {children}
        </div>
      </div>
    </div>
  )
}

PerformanceModalMobile.propTypes = {
  title: string.isRequired,
  onClose: func.isRequired,
  children: node.isRequired,
}

export default PerformanceModalMobile
